// Imports
import Button from "@mui/material/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControl from "@material-ui/core/FormControl";
import * as _ from "lodash";
// UI Imports
import Grid from "@material-ui/core/Grid/Grid";
import IconButton from "@material-ui/core/IconButton";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Modal from "@material-ui/core/Modal";
import Select from "@material-ui/core/Select";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconArrowBack from "@material-ui/icons/ArrowBack";
import CheckIcon from "@mui/icons-material/Check";
import IconClose from "@material-ui/icons/Close";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@material-ui/core";

// App Imports
import params from "../../../setup/config/params";
import {
  capitalizeFirstLetter,
  nullToEmptyString,
  slug,
  subString,
} from "../../../setup/helpers";
import { list as listCategories } from "../../category/api/actions/query";
import { messageShow } from "../../common/api/actions";
import EmptyMessage from "../../common/EmptyMessage";
import Image from "../../common/Image";
import BrandedLoading from "../../common/BrandedLoading";
import Pagination from "../../common/Pagination";
import SectionPaper from "../../common/SectionPaper";
import { listVendorsAll, detail as fetchUserDetail } from "../../user/api/actions/query";
import { createOrUpdate } from "../api/actions/mutation";
import { details, getUnitType } from "../api/actions/query";
import routes, { getImageSource } from "../api/routes";
import CSVToArray from "./csv_parser";
import styles from "./styles";

if (!Object.allWith) {
  /*  Non writeable enumerable configurable property of Object.prototype
      as a function in the form
      Object.allWith(predicate)
      Arguments
          predicate Function used to test the child property takes the argument
             obj the current object to test
          and will return true if the condition is meet
      Return
          An array of all objects that satisfy the predicate

      Example

      var test = {a : { key : 10, data: 100}, b : { key : 11, data: 100} };
      var res = test.allWith((obj)=>obj.key === 10);
      // res contains test.a
  */
  /*StackOverflow solution https://stackoverflow.com/questions/42252538/deep-search-json-object*/
  Object.defineProperty(Object.prototype, "allWith", {
    writable: false,
    enumerable: false,
    configurable: false,
    value: function (predicate) {
      var uObjects = [];
      var objects = [];
      if (typeof predicate !== "function") {
        throw new TypeError("predicate is not a function");
      }
      (function find(obj) {
        var key;
        if (predicate(obj) === true) {
          objects.push(obj);
        }
        for (key of Object.keys(obj)) {
          let o = obj[key];
          if (o && typeof o === "object") {
            if (!uObjects.find((obj) => obj === o)) {
              uObjects.push(o);
              find(o);
            }
          }
        }
      })(this);
      return objects;
    },
  });
}

// Component
class BulkCreate extends Component {
  constructor(props) {
    super(props);

    this.product = {
      _id: "",
      vendorId: "",
      categoryId: "",
      name: "",
      slug: "",
      brand: "",
      description: "",
      price: "",
      storePrice: "",
      VegNonVeg: "",
      priceDiscount: "",
      priceDiscounted: "",
      unit: "",
      unitTypeId: "",
      image: "default.jpg",
      gallery: [],
      // canSubscribe: true,
    };

    this.state = {
      isLoading: false,
      isLoadingSubmit: false,
      isUploadingFile: false,
      loader: false,
      rowsPerPage: 20,
      page: 0,
      setPage: 0,
      open: false,
      vendors: [],
      products: [],
      unitTypes: [],
      product: this.product,
      selectedProducts: [],
      selectAll: false,
      summaryDialogOpen: false,
      bulkSummary: null,
      vendorIndustryType: '',
    };
  }

  componentDidMount() {
    const {
      auth: { user },
      match: {
        params: { productId },
      },
      fetchUserDetail,
    } = this.props;
    this._isMounted = true;

    // Get categories
    this.getCategories();

    // Get vendors
    if (user.role === params.user.roles.vendor.key) {
      const { product } = this.state;
      product.vendorId = user._id;
      this.setState({
        product,
        vendorIndustryType: user.industryType || '',
      });
      if (fetchUserDetail) {
        fetchUserDetail({ userId: user._id })
          .then(({ data }) => {
            const userObj = data?.data?.user || data?.data?.userDetail;
            if (userObj?.industryType) {
              this.setState({ vendorIndustryType: userObj.industryType });
            }
          })
          .catch(err => console.error("Error fetching vendor detail:", err));
      }
    } else {
      this.getVendors();
    }

    this.fetchUnitTypes();

    // Get product for editing
    if (productId) {
      this.getProduct(productId);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  fetchUnitTypes = async () => {
    const { getUnitType, messageShow } = this.props;
    try {
      const { data } = await getUnitType();

      if (data.success) {
        this.setState({ unitTypes: data.data });
      }
    }
    catch (error) {
      messageShow("There was some error. Please try again");
    }
  };

  getVendors = async () => {
    const { listVendorsAll, messageShow } = this.props;

    try {
      const { data } = await listVendorsAll();

      if (data.success) {
        this.setState({
          vendors: data.data,
        });
      } else {
        messageShow(data.message);
      }
    } catch (error) {
      messageShow("There was some error. Please try again.");
    }
  };

  getCategories = () => {
    const { listCategories } = this.props;
    listCategories();
  };

  getProduct = async (productId) => {
    const { details, messageShow } = this.props;

    this.isLoadingToggle(true);
    try {
      const { data } = await details({ productId });
      if (data.success) {
        let product = data.data;
        product.vendorId = product.vendorId._id;
        product.categoryId = product.categoryId._id;

        this.setState({
          product,
        });
      }
    } catch (error) {
      messageShow("There was some error. Please try again");
    } finally {
      this.isLoadingToggle(false);
    }
  };

  createProduct = async (pidx, delItem = true, summary = null) => {
    const { createOrUpdate, messageShow } = this.props;
    const { products } = this.state;
    const product = { ...products[pidx] };

    if (product.categoryId && typeof product.categoryId === "object") {
      product.categoryId = product.categoryId._id;
    }
    if (product.unitTypeId && typeof product.unitTypeId === "object") {
      product.unitTypeId = product.unitTypeId._id;
    }

    try {
      const { data } = await createOrUpdate({ product });

      if (data && data.success) {
        // For individual operations, show the message immediately
        if (delItem) {
          messageShow(data.message || "Product processed successfully");
        }

        if (delItem) {
          this.deleteProduct(pidx);
        }

        // Determine operation type based on the backend response message
        const message = (data.message || '').toLowerCase();
        let operationType = 'add';

        if (message.includes('updated')) {
          operationType = 'update';
        } else if (message.includes('deleted')) {
          operationType = 'delete';
        } else if (message.includes('created') || message.includes('added')) {
          operationType = 'add';
        }

        return {
          success: true,
          message: data.message || "Product processed successfully",
          operationType: operationType
        };
      } else {
        const errorMessage = data?.message || "Failed to process product";
        const fullError = `Error at row ${pidx + 1}: ${product.name} - ${errorMessage}`;

        messageShow(fullError);
        return { success: false, message: fullError };
      }

    } catch (error) {
      console.error('API Error for product:', product.name, error);

      let backendMessage = "Unknown error from server";

      if (error?.response?.data) {
        backendMessage =
          error.response.data.message ||
          error.response.data.error ||
          error.response.data.msg ||
          JSON.stringify(error.response.data);
      } else if (error?.message) {
        backendMessage = error.message;
      }

      const errorMsgLower = backendMessage.toLowerCase();
      let errorMessage = `Error at row ${pidx + 1}: ${product.name}`;

      if (errorMsgLower.includes("duplicate") || errorMsgLower.includes("already exists")) {
        if (delItem) {
          errorMessage = `Error at row ${pidx + 1}: "${product.name}" already exists. Use update to modify.`;
          if (products[pidx]) {
            products[pidx].duplicateError = true;
          }
          messageShow(errorMessage);
          return { success: false, message: errorMessage };
        } else {
          if (delItem) {
            this.deleteProduct(pidx);
          }
          return {
            success: true,
            message: backendMessage,
            operationType: 'update'
          };
        }
      } else if (errorMsgLower.includes("category")) {
        errorMessage = `Error at row ${pidx + 1}: Invalid category for "${product.name}".`;
      } else {
        errorMessage = `Error at row ${pidx + 1}: ${product.name} - ${backendMessage}`;
      }

      messageShow(errorMessage);
      return { success: false, message: errorMessage };
    }
  };

  // Handle individual checkbox selection
  handleSelectProduct = (index) => {
    const { selectedProducts, products } = this.state;
    const newSelectedProducts = [...selectedProducts];

    if (newSelectedProducts.includes(index)) {
      const idx = newSelectedProducts.indexOf(index);
      newSelectedProducts.splice(idx, 1);
    } else {
      newSelectedProducts.push(index);
    }

    this.setState({
      selectedProducts: newSelectedProducts,
      selectAll: newSelectedProducts.length === products.filter(p => !p.duplicateError).length
    });
  };

  handleSelectAll = () => {
    const { selectAll, products } = this.state;

    if (selectAll) {
      this.setState({
        selectedProducts: [],
        selectAll: false
      });
    } else {
      const validProductIndices = products
        .map((product, index) => !product.duplicateError ? index : null)
        .filter(index => index !== null);

      this.setState({
        selectedProducts: validProductIndices,
        selectAll: true
      });
    }
  };

  onSubmitSelected = async () => {
    const { selectedProducts, products } = this.state;

    if (selectedProducts.length === 0) {
      this.props.messageShow("Please select at least one product to submit.");
      return;
    }

    this.isLoadingSubmitToggle(true);

    const successfulSubmissions = [];
    const summary = {
      added: 0,
      updated: 0,
      deleted: 0,
      errors: 0,
      total: selectedProducts.length,
      errorMessages: [],
    };

    for (let i = 0; i < selectedProducts.length; i++) {
      const productIndex = selectedProducts[i];
      const product = products[productIndex];

      if (product && !product.duplicateError) {
        try {
          const result = await this.createProduct(productIndex, false);

          if (result.success) {
            switch (result.operationType) {
              case 'add':
                summary.added += 1;
                break;
              case 'update':
                summary.updated += 1;
                break;
              case 'delete':
                summary.deleted += 1;
                break;
              default:
                summary.added += 1;
            }
            successfulSubmissions.push(productIndex);
          } else {
            summary.errors += 1;
            summary.errorMessages.push(result.message);
          }
        } catch (error) {
          summary.errors += 1;
          const errorMsg = `Error at row ${productIndex + 1}: ${product.name} - ${error.message || 'Unknown error'}`;
          summary.errorMessages.push(errorMsg);
        }
      } else if (product && product.duplicateError) {
        summary.errors += 1;
        summary.errorMessages.push(`Error at row ${productIndex + 1}: "${product.name}" - Duplicate product detected`);
      }
    }

    // Remove successfully submitted products
    let updatedProducts = [...products];
    if (successfulSubmissions.length > 0) {
      updatedProducts = products.filter((_, index) =>
        !successfulSubmissions.includes(index)
      );
    }

    this.setState({
      products: updatedProducts,
      selectedProducts: [],
      selectAll: false,
    });

    this.isLoadingSubmitToggle(false);
    this.showBulkSummaryDialog(summary);
  };

  onCreateAll = async (event) => {
    event.preventDefault();
    const { products } = this.state;

    this.isLoadingSubmitToggle(true);

    const summary = {
      added: 0,
      updated: 0,
      deleted: 0,
      errors: 0,
      total: products.length,
      errorMessages: [],
    };

    const successfulSubmissions = [];

    for (let i = 0; i < products.length; i++) {
      const product = products[i];

      if (product && !product.duplicateError) {
        try {
          const result = await this.createProduct(i, false);

          if (result.success) {
            switch (result.operationType) {
              case 'add':
                summary.added += 1;
                break;
              case 'update':
                summary.updated += 1;
                break;
              case 'delete':
                summary.deleted += 1;
                break;
              default:
                summary.added += 1;
            }
            successfulSubmissions.push(i);
          } else {
            summary.errors += 1;
            summary.errorMessages.push(result.message);
          }
        } catch (error) {
          summary.errors += 1;
          const errorMsg = `Error at row ${i + 1}: ${product.name} - ${error.message || 'Unknown error'}`;
          summary.errorMessages.push(errorMsg);
        }
      } else if (product && product.duplicateError) {
        summary.errors += 1;
        summary.errorMessages.push(`Error at row ${i + 1}: "${product.name}" - Duplicate product detected`);
      }
    }

    // Remove successfully submitted products
    let updatedProducts = [...products];
    if (successfulSubmissions.length > 0) {
      updatedProducts = products.filter((_, index) =>
        !successfulSubmissions.includes(index)
      );
    }

    this.setState({
      products: updatedProducts,
    });

    this.isLoadingSubmitToggle(false);
    this.showBulkSummaryDialog(summary);
  };

  isLoadingToggle = (isLoading) => {
    this.setState({
      isLoading,
    });
  };

  isLoadingSubmitToggle = (isLoadingSubmit) => {
    this.setState({
      isLoadingSubmit,
    });
  };

  isUploadingFileToggle = (isUploadingFile) => {
    this.setState({
      isUploadingFile,
    });
  };

  onType = ({ target: { name, value } }) => {
    const { product } = this.state;

    if (name === "name") {
      product.slug = slug(value);
    }

    product[name] = name === "slug" ? value : capitalizeFirstLetter(value);

    if (name === "price" || name === "priceDiscount") {
      product.priceDiscounted =
        product.priceDiscount !== ""
          ? (
            product.price -
            product.price * (product.priceDiscount / 100)
          ).toFixed(2)
          : product.price;
    }

    this.setState({
      product,
    });
  };

  onSelect = ({ target: { name, value } }) => {
    this.setState((prevState) => {
      const product = { ...prevState.product, [name]: value };
      let vendorIndustryType = prevState.vendorIndustryType;
      if (name === "vendorId" && value) {
        const selected = (prevState.vendors || []).find((v) => v._id === value);
        if (selected?.industryType) {
          vendorIndustryType = selected.industryType;
        }
      }
      return {
        product,
        vendorIndustryType,
      };
    });
    this.isUploadingFileToggle(false);
  };

  getCategoryById = async (categorySlug) => {
    const { categories } = this.props;
    let res = null;
    categories.list.map((obj) => {
      if (obj.category.slug === categorySlug) {
        res = obj.category;
        return true;
      } else {
        if (obj.subCategories?.length > 0) {
          obj.subCategories.map((eSub) => {
            if (eSub.slug === categorySlug) {
              res = eSub;
              return true;
            }
          });
        }
      }
    });
    return res;
  };
  showBulkSummaryDialog = (summary) => {
    this.setState({
      summaryDialogOpen: true,
      bulkSummary: summary,
    });
  };

  handleCloseSummaryDialog = () => {
    this.setState({ summaryDialogOpen: false });
  };

  onVendorCheck = async () => {
    const { messageShow } = this.props;
    const { product } = this.state;

    if (product.vendorId === "" || product.vendorId === null) {
      this.isUploadingFileToggle(true);
      messageShow("Please Select Vendor.");
    } else {
      this.onUpload();
    }
  };

  onUpload = async (event) => {
    this.setState({
      loader: true,
      products: [],
      selectedProducts: [],
      selectAll: false,
      open: true,
    });

    const { messageShow } = this.props;
    const fileContent = event.target.files[0];
    const reader = new FileReader();

    reader.onload = async () => {
      this.setState({ loader: false });

      const data = CSVToArray(reader.result);
      const headers = data.shift();
      const finalResult = [];

      for (const eachItem of data) {
        if (eachItem.length === headers.length) {
          const eachObj = _.zipObject(headers, eachItem);

          // CATEGORY ID
          const categoryData = await this.getCategoryById(eachObj["category slug"]);
          if (categoryData?._id) {
            eachObj.categoryId = categoryData;
          } else {
            eachObj.categoryId = { _id: "", name: "Invalid" };
          }

          // VENDOR ID
          const vendorName = eachObj.vendorName?.trim();
          const matchedVendor = this.state.vendors.find(
            (v) => v.name?.toLowerCase() === vendorName?.toLowerCase()
          );
          if (matchedVendor) {
            eachObj.vendorId = matchedVendor._id;
          } else {
            eachObj.vendorId = "";
            messageShow(`Invalid vendor "${vendorName}". Please enter valid vendorId`);
          }

          // UNIT TYPE ID
          const unitTypeName = eachObj.unitType?.trim();
          if (!unitTypeName) {
            eachObj.unitTypeId = "";
          } else {
            const unitType = this.state.unitTypes.find(
              (unit) => unit?.name?.toLowerCase() === unitTypeName.toLowerCase()
            );
            eachObj.unitTypeId = unitType ? unitType._id : "";
            if (!unitType) {
              messageShow(`Please enter a valid Unit Type.`);
            }
          }

          // VEG / NONVEG
          const vegOrNonVeg = eachObj.vegOrNonVeg?.toLowerCase();
          eachObj.isVeg = vegOrNonVeg === "veg" ? "1" : "";
          eachObj.isNonVeg = ["nonveg", "non-veg"].includes(vegOrNonVeg) ? "1" : "";

          // Availability
          if (eachObj.available_days) {
            eachObj.available_days = eachObj.available_days.split(',').map(d => d.trim()).filter(d => d);
          } else {
            eachObj.available_days = [];
          }

          eachObj.available_time = {
            startTime: eachObj.startTime || "",
            endTime: eachObj.endTime || ""
          };

          // Business fields
          eachObj.detailedDescription = eachObj.detailedDescription || eachObj["detailed description"] || "";
          eachObj.buttonText = eachObj.buttonText || eachObj["button text"] || "";
          eachObj.buttonLink = eachObj.buttonLink || eachObj["button link"] || "";
          eachObj.unit = eachObj.unit || "";
          eachObj.storePrice = eachObj.storePrice || eachObj.price || 0;

          // SEO TAGS
          eachObj.seo = {
            title: eachObj.name || "",
            description: eachObj.description || "",
            keywords: eachObj.seoKeyword || eachObj["seo keyword"] || eachObj.keyword || ""
          };

          eachObj.image = eachObj.image && eachObj.image.trim() !== "" ? eachObj.image.trim() : "default.jpg";
          eachObj.gallery = eachObj.gallery || [];
          eachObj.mode = "bulkcreate";
          eachObj.duplicateError = false;

          finalResult.push(eachObj);
        }
      }

      // Check for duplicate names
      const nameMap = {};
      finalResult.forEach((product, i) => {
        const key = `${product.vendorId}__${product.name?.trim().toLowerCase()}`;
        if (nameMap[key]) {
          product.duplicateError = true;
          finalResult[nameMap[key]].duplicateError = true;
        } else {
          nameMap[key] = i;
        }
      });

      if (this._isMounted) {
        this.setState({ products: finalResult });
      }

      this.textInput.value = "";
      this.isUploadingFileToggle(false);
    };

    reader.onerror = () => {
      messageShow("There was some error. Please try again.");
      this.isUploadingFileToggle(false);
    };

    messageShow("Uploading file, please wait...");
    reader.readAsText(fileContent);
    this.isUploadingFileToggle(true);
  };

  deleteProduct = (pidx) => {
    const { products, selectedProducts } = this.state;

    products.splice(pidx, 1);

    const newSelectedProducts = selectedProducts
      .filter(index => index !== pidx)
      .map(index => index > pidx ? index - 1 : index);

    this.setState({
      products,
      selectedProducts: newSelectedProducts,
      selectAll: newSelectedProducts.length === products.filter(p => !p.duplicateError).length
    });
  };

  back = () => {
    const { history } = this.props;

    if (history.length > 2) {
      history.goBack();
    } else {
      history.push(routes.productList.path(1));
    }
  };

  // onChangeCanSubscribe = (event) => {
  //   const { product } = this.state;

  //   product.canSubscribe = event.target.checked;

  //   this.setState({
  //     product,
  //   });
  // };

  // Pagination methods
  tablePaginationActions = (props) => {
    const handleBackButtonClick = (event) => {
      this.handleChangePage(event, this.state.page - 1);
    };

    const handleNextButtonClick = (event) => {
      this.handleChangePage(event, this.state.page + 1);
    };
    return (
      <div style={{ width: "200px" }}>
        <Grid container justifyContent="space-between">
          <IconButton
            onClick={handleBackButtonClick}
            disabled={this.state.page === 0}
            aria-label="Previous Page"
          >
            <KeyboardArrowLeft />
          </IconButton>
          <IconButton
            onClick={handleNextButtonClick}
            disabled={
              this.state.page >=
              Math.ceil(this.count / this.state.rowsPerPage) - 1
            }
            aria-label="Next Page"
          >
            <KeyboardArrowRight />
          </IconButton>
        </Grid>
      </div>
    );
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: parseInt(event.target.value, 0) });
  };

  render() {
    const {
      auth: { user },
      match: {
        params: { productId },
      },
      classes,
    } = this.props;
    const {
      products,
      isLoading,
      isLoadingSubmit,
      isUploadingFile,
      vendors,
      product,
      selectedProducts,
      selectAll
    } = this.state;

    const validProductsCount = products.filter(p => !p.duplicateError).length;

    return (
      <>
        <div>
          <Toolbar className={classes.toolbar}>
            <IconButton
              className={classes.menuButton}
              color="inherit"
              onClick={this.back}
            >
              <IconArrowBack />
            </IconButton>

            <Typography variant="h6" color="inherit" className={classes.grow}>
              {productId ? "Edit" : "Create"} Bulk Products
            </Typography>
          </Toolbar>

          <Grid item xs={12} lg={6}>
            <SectionPaper padding>
              {isLoading ? (
                <BrandedLoading />
              ) : (
                <form>
                  {this.state.loader ? (
                    <Modal
                      open={this.state.open}
                      style={{ backgroundColor: "rgba(0, 0, 0, .9)" }}
                    >
                      <Grid
                        container
                        alignItems="center"
                        justifyContent="center"
                        style={{ height: "100vh" }}
                      >
                        <CircularProgress className={classes.progress} />
                      </Grid>
                    </Modal>
                  ) : null}
                  <Grid container className={classes.buttonUpload}>
                    <Typography
                      variant="h6"
                      color="inherit"
                      className={classes.grow}
                    >
                      Choose Vendor for Adding New Product
                    </Typography>
                    {user.role === params.user.roles.admin.key && (
                      <FormControl
                        fullWidth
                        className={classes.select}
                      // required={true}
                      >
                        <InputLabel htmlFor="vendorId">Vendor</InputLabel>
                        <Select
                          value={nullToEmptyString(product.vendorId)}
                          onChange={this.onSelect}
                          inputProps={{
                            name: "vendorId",
                            id: "vendorId",
                          }}
                        >
                          <MenuItem value="">
                            <em>None</em>
                          </MenuItem>
                          {vendors.length > 0 &&
                            vendors.map((item) => (
                              <MenuItem
                                key={item._id}
                                value={item._id}
                              >{`${item.name} (${item.email})`}</MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    )}

                    <Grid item sm={6}>
                      <div style={{ marginTop: 20, marginBottom: 20 }}>
                        <input
                          accept={".csv"}
                          style={{ display: "none" }}
                          id={"contained-button-file"}
                          type={"file"}
                          onChange={this.onUpload}
                          ref={(ref) => (this.textInput = ref)}
                        />
                        <label htmlFor={"contained-button-file"}>
                          <Button
                            variant={"outlined"}
                            component={"span"}
                            type={"file"}
                            disabled={isUploadingFile}
                            fullWidth
                          >
                            Upload CSV file
                          </Button>
                        </label>
                      </div>
                    </Grid>
                    <Grid item sm={12}>
                      <Typography variant="subtitle1" gutterBottom>
                        Steps to Bulk Upload:
                      </Typography>
                      <ol style={{ paddingLeft: '1.2rem', marginTop: 0 }}>
                        <li>📥 Download the products file.</li>
                        <li>✏️ Make your changes.</li>
                        <li>⚙️ In the <strong>Action</strong> column, specify <strong>Add</strong>, <strong>Update</strong>, or <strong>Delete</strong> for each row.</li>
                        <li>📤 Upload the updated file using the button <strong>UPLOAD CSV FILE</strong>.</li>
                      </ol>
                      <Typography variant="body2" style={{ marginTop: '8px' }}>
                        <strong>🛈Note:</strong>
                        <ul style={{ margin: '4px 0 0 0', paddingLeft: '1.2rem' }}>
                          <li><strong>ADD:</strong> If the product does not exist, it will be added. If the product already exists, it will be updated. (Default if left empty)</li>
                          <li><strong>UPDATE:</strong> Updates the product only if it already exists. If the product does not exist, an error will be displayed.</li>
                          <li><strong>DELETE:</strong> Deletes the product if it exists.</li>
                        </ul>
                      </Typography>
                    </Grid>
                  </Grid>
                </form>
              )}
            </SectionPaper>
          </Grid>

          <Grid item xs={12}>
            <SectionPaper>
              {isLoading ? (
                <BrandedLoading />
              ) : products.length === 0 ? (
                <EmptyMessage message={"You have not added any products yet."} />
              ) : (
                <>
                  {/* Selection Controls */}
                  <Grid container alignItems="center" style={{ padding: '16px', borderBottom: '1px solid #e0e0e0' }}>
                    <Grid item>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={selectAll}
                            onChange={this.handleSelectAll}
                            disabled={validProductsCount === 0}
                          />
                        }
                        label={`Select All (${selectedProducts.length}/${validProductsCount})`}
                      />
                    </Grid>
                    <Grid item style={{ marginLeft: 'auto' }}>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={this.onSubmitSelected}
                        disabled={selectedProducts.length === 0 || isLoadingSubmit}
                        startIcon={isLoadingSubmit ? <CircularProgress size={20} /> : null}
                      >
                        {isLoadingSubmit ? 'Submitting...' : `Submit Selected (${selectedProducts.length})`}
                      </Button>
                    </Grid>
                  </Grid>

                  {(() => {
                    const indType = (this.state.vendorIndustryType || user.industryType || "").trim().toLowerCase();
                    const isBusiness = indType === "business" || indType === "saas";

                    return (
                      <Table padding={"normal"}>
                        <TableHead>
                          <TableRow>
                            <TableCell width={50}>Select</TableCell>
                            <TableCell width={85}>Image</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Category</TableCell>
                            <TableCell>Brand</TableCell>
                            {isBusiness ? (
                              <>
                                <TableCell>Price</TableCell>
                                <TableCell>Unit</TableCell>
                                <TableCell>Button Text</TableCell>
                              </>
                            ) : (
                              <>
                                <TableCell>VegOrNonVeg</TableCell>
                                <TableCell>Stock</TableCell>
                                <TableCell>Price</TableCell>
                              </>
                            )}
                            <TableCell
                              width={
                                user.role === params.user.roles.admin.key ? 180 : 90
                              }
                              align="center"
                            >
                              Actions
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {products
                            .slice(
                              this.state.page * this.state.rowsPerPage,
                              this.state.page * this.state.rowsPerPage + this.state.rowsPerPage
                            )
                            .map(({ image, name, categoryId, openingStock, duplicateError, isVeg, isNonVeg, brand, storePrice, price, unit, buttonText }, i) => {
                              const actualIndex = this.state.page * this.state.rowsPerPage + i;
                              let vegStatus = "";
                              if (isVeg) {
                                vegStatus = "Veg";
                              } else if (isNonVeg) {
                                vegStatus = "NonVeg";
                              }
                              return (
                                <TableRow
                                  key={actualIndex}
                                  style={{
                                    backgroundColor: duplicateError
                                      ? "rgba(255, 0, 0, 0.1)"
                                      : "inherit",
                                  }}
                                >
                                  <TableCell>
                                    <Checkbox
                                      checked={selectedProducts.includes(actualIndex)}
                                      onChange={() => this.handleSelectProduct(actualIndex)}
                                      disabled={duplicateError}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <Image
                                      src={getImageSource(image)}
                                      defaultSrc={getImageSource()}
                                    />
                                  </TableCell>
                                  <TableCell>{subString(name, 30)}</TableCell>
                                  <TableCell>{categoryId?.name || categoryId}</TableCell>
                                  <TableCell>{brand || '-'}</TableCell>
                                  {isBusiness ? (
                                    <>
                                      <TableCell>{storePrice || price || 0}</TableCell>
                                      <TableCell>{unit || '-'}</TableCell>
                                      <TableCell>{buttonText || '-'}</TableCell>
                                    </>
                                  ) : (
                                    <>
                                      <TableCell>
                                        {vegStatus}
                                      </TableCell>
                                      <TableCell>{openingStock || 0}</TableCell>
                                      <TableCell>{storePrice || price || 0}</TableCell>
                                    </>
                                  )}
                                  <TableCell>
                                    <Grid item xs={12} className={classes.buttonsContainer}>
                                      <IconButton
                                        type="button"
                                        aria-label="Close"
                                        color="secondary"
                                        onClick={() => this.deleteProduct(actualIndex)}
                                      >
                                        <IconClose />
                                      </IconButton>
                                      <IconButton
                                        type="button"
                                        aria-label="Save"
                                        color="primary"
                                        onClick={() => this.createProduct(actualIndex)}
                                      >
                                        <CheckIcon />
                                      </IconButton>
                                    </Grid>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[20, 50, 100]}
                              count={products.length}
                              rowsPerPage={this.state.rowsPerPage}
                              page={this.state.page}
                              onPageChange={this.handleChangePage}
                              onRowsPerPageChange={this.handleChangeRowsPerPage}
                              //ActionsComponent={this.tablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    );
                  })()}
                  <Pagination count={10} route={routes.productList} />
                </>
              )}
            </SectionPaper>
          </Grid>
        </div>
        <Dialog open={this.state.summaryDialogOpen} onClose={this.handleCloseSummaryDialog}>
          <DialogTitle>Bulk Upload Summary</DialogTitle>
          <DialogContent>
            {this.state.bulkSummary && (
              <div>
                <p><strong>Total:</strong> {this.state.bulkSummary.total} Products</p>
                <p><strong>Added:</strong> {this.state.bulkSummary.added} Products Added successfully</p>
                <p><strong>Updated:</strong> {this.state.bulkSummary.updated} Products Updated successfully</p>
                <p><strong>Deleted:</strong> {this.state.bulkSummary.deleted} Products Deleted successfully</p>
                <p><strong>Errors:</strong> {this.state.bulkSummary.errors} Products Failed</p>
                {this.state.bulkSummary.errorMessages.length > 0 && (
                  <>
                    <p><strong>Error Details:</strong></p>
                    <ul>
                      {this.state.bulkSummary.errorMessages.map((msg, index) => (
                        <li key={index}>{msg}</li>
                      ))}
                    </ul>
                  </>
                )}
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseSummaryDialog} color="primary">
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

// Component Properties
BulkCreate.propTypes = {
  auth: PropTypes.object.isRequired,
  categories: PropTypes.object.isRequired,
  details: PropTypes.func.isRequired,
  createOrUpdate: PropTypes.func.isRequired,
  listVendorsAll: PropTypes.func.isRequired,
  listCategories: PropTypes.func.isRequired,
  getUnitType: PropTypes.func.isRequired,
  messageShow: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

// Component State
function bulkCreateState(state) {
  return {
    auth: state.auth,
    categories: state.categories,
  };
}

export default connect(bulkCreateState, {
  details,
  createOrUpdate,
  listVendorsAll,
  listCategories,
  messageShow,
  getUnitType,
  fetchUserDetail,
})(withStyles(styles)(BulkCreate));

